export default __webpack_public_path__ + "static/media/logo_5.0c89766b.jpg";